import instance from 'utils/axios/instance.axios';
import { PERSONNEL_ADJUSTMENTS } from './_constant';

export const reviewPersonnelAdjustment = ({ id, body = {} }) =>
  instance.post(PERSONNEL_ADJUSTMENTS.REVIEW(id), body);

export const getPersonnelAdjustmentById = (id) => instance.get(PERSONNEL_ADJUSTMENTS.GET_BY_ID(id));

export const getPersonnelAdjustmentByProjectId = (projectId) =>
  instance.get(PERSONNEL_ADJUSTMENTS.GET_BY_PROJECT_ID(projectId));

export const downloadPersonnelAdjustmentDocxFile = (id) =>
  instance.get(PERSONNEL_ADJUSTMENTS.DOWNLOAD_DOCX_FILE(id), {
    responseType: 'blob',
  });

export const downloadPersonnelAdjustmentPdfFile = (id) =>
  instance.get(PERSONNEL_ADJUSTMENTS.DOWNLOAD_PDF_FILE(id), {
    responseType: 'blob',
  });
